import React from 'react';
import {
    WORKOUT_REPS_MODE_OPTIONS,
    normalizeWorkoutRepsMode,
} from '../../../constants/workoutRepsMode';
import { editorControlClass, editorLabelClass as labelClass, editorNumClass as numClass } from './ExerciseEditorParts';


const modeClass = `h-9 w-32 shrink-0 px-2 ${editorControlClass}`;

/**
 * WEBAPP-15: reps fisso / range / cedimento per righe template (usa ripetizioni_min/max).
 */
export default function TemplateRepsInputs({ exercise, onUpdate }) {
    const isCardio = exercise.is_cardio === 1 || exercise.is_cardio === true;
    const isIsometric = exercise.is_isometric_scheda === 1 || exercise.is_isometric_scheda === true;

    if (isCardio) {
        return (
            <div>
                <label className={labelClass}>Minuti</label>
                <input
                    type="number"
                    min="1"
                    value={exercise.ripetizioni_max ?? ''}
                    onChange={(e) => onUpdate('ripetizioni_max', parseInt(e.target.value, 10) || '')}
                    onFocus={(e) => e.target.select()}
                    className={numClass}
                />
            </div>
        );
    }

    if (isIsometric) {
        return (
            <div>
                <label className={labelClass}>Secondi</label>
                <input
                    type="number"
                    min="1"
                    value={exercise.ripetizioni_max ?? ''}
                    onChange={(e) => onUpdate('ripetizioni_max', parseInt(e.target.value, 10) || '')}
                    onFocus={(e) => e.target.select()}
                    className={numClass}
                />
            </div>
        );
    }

    const repsMode = normalizeWorkoutRepsMode(exercise.reps_mode);

    const handleModeChange = (mode) => {
        onUpdate('reps_mode', mode);
        if (mode === 'fixed') {
            onUpdate('ripetizioni_min', 0);
            if (!exercise.ripetizioni_max) onUpdate('ripetizioni_max', 12);
        } else if (mode === 'range') {
            onUpdate('ripetizioni_min', exercise.ripetizioni_min ?? 8);
            onUpdate('ripetizioni_max', exercise.ripetizioni_max ?? 12);
        } else if (mode === 'amrap') {
            onUpdate('ripetizioni_min', 0);
            onUpdate('ripetizioni_max', 0);
        }
    };

    return (
        <div>
            <label className={labelClass}>Ripetizioni</label>
            <div className="flex flex-wrap items-center gap-2">
                <select
                    value={repsMode}
                    onChange={(e) => handleModeChange(e.target.value)}
                    className={modeClass}
                    aria-label="Modalità ripetizioni"
                >
                    {WORKOUT_REPS_MODE_OPTIONS.map((opt) => (
                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                    ))}
                </select>

                {repsMode === 'fixed' && (
                    <input
                        type="number"
                        min="1"
                        value={exercise.ripetizioni_max ?? ''}
                        onChange={(e) => onUpdate('ripetizioni_max', parseInt(e.target.value, 10) || '')}
                        onFocus={(e) => e.target.select()}
                        className={numClass}
                        placeholder="12"
                        aria-label="Ripetizioni"
                    />
                )}

                {repsMode === 'range' && (
                    <>
                        <input
                            type="number"
                            min="1"
                            value={exercise.ripetizioni_min ?? ''}
                            onChange={(e) => onUpdate('ripetizioni_min', parseInt(e.target.value, 10) || '')}
                            onFocus={(e) => e.target.select()}
                            className={numClass}
                            placeholder="8"
                            aria-label="Ripetizioni minime"
                        />
                        <span className="text-xs text-gray-400" aria-hidden>–</span>
                        <input
                            type="number"
                            min="1"
                            value={exercise.ripetizioni_max ?? ''}
                            onChange={(e) => onUpdate('ripetizioni_max', parseInt(e.target.value, 10) || '')}
                            onFocus={(e) => e.target.select()}
                            className={numClass}
                            placeholder="12"
                            aria-label="Ripetizioni massime"
                        />
                    </>
                )}
            </div>
        </div>
    );
}
